import { HiReceiptTax } from "react-icons/hi";
import { MdRequestQuote } from "react-icons/md";
import { ADD_BILL } from "../../routes";


// export const HO_ROLE = "ho";

// Form Modes
export const FORM_MODES = {
  ADD: "ADD",
  VIEW: "VIEW",
};

// Validation Messages
export const VALIDATION_MESSAGES = {
  DATE_REQUIRED: "Date is required",
  AMOUNT_REQUIRED: "Amount is required",
  CATEGORY_REQUIRED: "Category is required",
  FILE_REQUIRED: "File is required",
};

// Labels for Table / Forms
export const BILL_LABELS = {
  project_name: "Project",
  site: "Site",
  site_name: "Site",
  date: "Date",
  user_name: "User",
  type: "Type",
  amount: "Amount",
  category: "Category",
  category_name: "Category",
  status: "Status",
  actions: "Actions",
};

// Table Columns
export const BILL_COLUMNS = {
  ADMIN: [
    "project_name",
    "site_name",
    "type",
    "category_name",
    "date",
    "amount",
    "user_name",
    "status",
    "actions",
  ],
  USER: [
    "site_name",
    "type",
    "category_name",
    "date",
    "amount",
    "status",
    "actions",
  ],
};

// Titles
export const FORM_TITLES = {
  ADD: "Add Bill",
  VIEW: "View Bill",
};

// Button Texts
export const BUTTON_TEXT = {
  ADD_BILL: "+ Add Bill",
  SUBMIT: "Submit",
  SUBMITTING: "Submitting...",
  APPROVE: "Approve",
  REJECT: "Reject",
  DELETE: "Delete Bill",
  BACK: "Back",
  CANCEL: "Cancel",
};

// Icon Titles
export const ICON_TITLES = {
  VIEW: "View Bill",
  APPROVE: "Approve",
  REJECT: "Reject",
  DELETE: "Delete Bill",
};

// Toast Messages
export const TOAST_MESSAGES = {
  BILLS_FETCH_ERROR: "Failed to fetch bills",
  BILL_ADD_SUCCESS: "Bill added successfully",
  BILL_ADD_ERROR: "Failed to add bill",
  BILL_UPDATE_SUCCESS: "Bill updated successfully",
  BILL_UPDATE_ERROR: "Failed to update bill",
  BILL_DELETE_SUCCESS: "Bill deleted successfully",
  BILL_DELETE_ERROR: "Failed to delete bill",
  STATUS_UPDATE_SUCCESS: (status) =>
    `Bill ${status.toLowerCase()} successfully`,
  STATUS_UPDATE_ERROR: "Failed to update status",
  DELETE_ALERT: "Are you sure you want to delete this bill?",
  USER_FETCH_ERROR: "Failed to fetch logged-in user",
};

// Status Constants
export const STATUS = {
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  PENDING_L1_APPROVAL: "PENDING_L1_APPROVAL",
  PENDING_L2_APPROVAL: "PENDING_L2_APPROVAL",
};

// Default Status Dropdown Options
export const DEFAULT_STATUS_OPTIONS = [
  {label:"All", value:""},
  { label: "Approved", value: "APPROVED" },
  { label: "Rejected", value: "REJECTED" },
  { label: "Pending L1 Approval", value: "PENDING_L1_APPROVAL" },
  { label: "Pending L2 Approval", value: "PENDING_L2_APPROVAL" },
];

// Export Columns for Excel/CSV
export const EXCEL_FILE_COLUMNS = [
  { label: "Site", value: "site_name" },
  { label: "Amount", value: "amount" },
  { label: "Category", value: "category_name" },
  {
    label: "Date",
    value: (item) => new Date(item.date).toLocaleDateString(),
  },
  { label: "User", value: "user_name" },
  { label: "Status", value: "status" },
  { label: "File", value: "bill_file" },
];

// Bill Types Dropdown
export const TYPES_OPTIONS = [
  { label: "All", value: "" },
  { label: "Purchase", value: "PURCHASE" },
  { label: "Reimbursement", value: "REIMBURSEMENT" },
];

// Popup Cards for Adding Bills
const commonCss = "w-10 h-10 md:w-12 md:h-12";
const subMenuCss = "items-center";

export const BILL_POPUP_FIELDS = [
  {
    title: "Bill",
    label: "Add Purchase",
    icon: (
      <HiReceiptTax className={`${commonCss} text-yellow-600 ${subMenuCss}`} />
    ),
    link: ADD_BILL.replace(":billType", "purchase"),
  },
  {
    title: "Bill",
    label: "Add Reimbursement",
    icon: (
      <MdRequestQuote
        className={`${commonCss} text-yellow-600 ${subMenuCss}`}
      />
    ),
    link: ADD_BILL.replace(":billType", "reimbursement"),
  },
]; 

// Misc
export const MISC = {
  NO_BILLS_FOUND: "No bills found",
  NOT_AVAILABLE: "N/A",
};



